import { name } from './name';
import { resourceType } from './resourceType';
import { status } from './status';
import { statusMessage } from './statusMessage';
import { actions } from './actions';

export const columns = [name, resourceType, status, statusMessage, actions];
